import { isLoading } from "../redux/slice/userSlice";
import store from "../redux/store";

export function startApiLoader() {
  store.dispatch(
    isLoading({
      isLoading: true,
    })
  );
}

export function endApiLoader() {
  store.dispatch(
    isLoading({
      isLoading: false,
    })
  );
}
